var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _vm.value
        ? _c("ModalFullScreen", {
            attrs: { size: "xl", title: "Invite Managers" },
            on: { close: _vm.handleCancel },
            scopedSlots: _vm._u(
              [
                {
                  key: "content",
                  fn: function () {
                    return [
                      _c(
                        "ModalTabs",
                        {
                          attrs: { tabs: _vm.tabs },
                          on: { tabIndexUpdated: _vm.updateTabIndex },
                        },
                        [
                          _vm.selectedTabIndex === 0
                            ? _c(
                                "div",
                                {
                                  staticClass: "border-t-2 border-transparent",
                                },
                                [
                                  _c("ValidationObserver", {
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function ({ invalid }) {
                                            return [
                                              _c(
                                                "form",
                                                {
                                                  on: {
                                                    submit: function ($event) {
                                                      $event.preventDefault()
                                                      return _vm.invite()
                                                    },
                                                  },
                                                },
                                                [
                                                  true
                                                    ? _c("div", [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "pb-5 pt-4 flex justify-between",
                                                          },
                                                          [
                                                            _c(
                                                              "h4",
                                                              {
                                                                staticClass:
                                                                  "text-base font-light",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " Invite managers to your organization. "
                                                                ),
                                                              ]
                                                            ),
                                                            _c(
                                                              "div",
                                                              [
                                                                _c("UiButton", {
                                                                  staticClass:
                                                                    "m-0",
                                                                  attrs: {
                                                                    variant:
                                                                      "outline-black",
                                                                    buttonText:
                                                                      "Add",
                                                                    id: "addManager",
                                                                    size: "sm",
                                                                  },
                                                                  on: {
                                                                    click:
                                                                      _vm.add,
                                                                  },
                                                                  scopedSlots:
                                                                    _vm._u(
                                                                      [
                                                                        {
                                                                          key: "icon",
                                                                          fn: function () {
                                                                            return [
                                                                              _c(
                                                                                "PlusIcon",
                                                                                {
                                                                                  staticClass:
                                                                                    "w-2.5 h-2.5",
                                                                                }
                                                                              ),
                                                                            ]
                                                                          },
                                                                          proxy: true,
                                                                        },
                                                                        {
                                                                          key: "hover-icon",
                                                                          fn: function () {
                                                                            return [
                                                                              _c(
                                                                                "HoveredIcon",
                                                                                {
                                                                                  staticClass:
                                                                                    "w-4 h-4",
                                                                                }
                                                                              ),
                                                                            ]
                                                                          },
                                                                          proxy: true,
                                                                        },
                                                                      ],
                                                                      null,
                                                                      true
                                                                    ),
                                                                }),
                                                              ],
                                                              1
                                                            ),
                                                          ]
                                                        ),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "customModal",
                                                          },
                                                          _vm._l(
                                                            _vm.users,
                                                            function (
                                                              item,
                                                              index
                                                            ) {
                                                              return _c(
                                                                "UserInvitationData",
                                                                {
                                                                  key: index,
                                                                  attrs: {
                                                                    userEmail:
                                                                      item.email,
                                                                    userGivenName:
                                                                      item.givenName,
                                                                    userCompanyName:
                                                                      item.company,
                                                                    euniceValidator:
                                                                      _vm.euniceValidator,
                                                                    userFamilyName:
                                                                      item.familyName,
                                                                    processing:
                                                                      item.processing,
                                                                    userId:
                                                                      item.id,
                                                                    regexError:
                                                                      _vm.regexError,
                                                                    companyId:
                                                                      _vm.companyId,
                                                                    index:
                                                                      index,
                                                                    userSource:
                                                                      _vm.users,
                                                                    isManager: true,
                                                                    usersToCheck:
                                                                      _vm.invitationTabUsers,
                                                                    allowDelete:
                                                                      _vm.allowDelete,
                                                                  },
                                                                  on: {
                                                                    "update:userEmail":
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.$set(
                                                                          item,
                                                                          "email",
                                                                          $event
                                                                        )
                                                                      },
                                                                    "update:user-email":
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.$set(
                                                                          item,
                                                                          "email",
                                                                          $event
                                                                        )
                                                                      },
                                                                    "update:userGivenName":
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.$set(
                                                                          item,
                                                                          "givenName",
                                                                          $event
                                                                        )
                                                                      },
                                                                    "update:user-given-name":
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.$set(
                                                                          item,
                                                                          "givenName",
                                                                          $event
                                                                        )
                                                                      },
                                                                    "update:userCompanyName":
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.$set(
                                                                          item,
                                                                          "company",
                                                                          $event
                                                                        )
                                                                      },
                                                                    "update:user-company-name":
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.$set(
                                                                          item,
                                                                          "company",
                                                                          $event
                                                                        )
                                                                      },
                                                                    "update:userFamilyName":
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.$set(
                                                                          item,
                                                                          "familyName",
                                                                          $event
                                                                        )
                                                                      },
                                                                    "update:user-family-name":
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.$set(
                                                                          item,
                                                                          "familyName",
                                                                          $event
                                                                        )
                                                                      },
                                                                    "update:processing":
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.$set(
                                                                          item,
                                                                          "processing",
                                                                          $event
                                                                        )
                                                                      },
                                                                    "update:userId":
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.$set(
                                                                          item,
                                                                          "id",
                                                                          $event
                                                                        )
                                                                      },
                                                                    "update:user-id":
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.$set(
                                                                          item,
                                                                          "id",
                                                                          $event
                                                                        )
                                                                      },
                                                                    delete:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.handleDeleteRow(
                                                                          index
                                                                        )
                                                                      },
                                                                  },
                                                                }
                                                              )
                                                            }
                                                          ),
                                                          1
                                                        ),
                                                      ])
                                                    : _vm._e(),
                                                  _c("ModalSectionsDivider"),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "flex justify-end",
                                                    },
                                                    [
                                                      _c("UiButton", {
                                                        staticClass: "mr-3",
                                                        attrs: {
                                                          variant: "outline",
                                                          size: "lg",
                                                          id: "cancelInvite",
                                                          buttonClasses:
                                                            "w-20 customPadding",
                                                          buttonText: "Cancel",
                                                        },
                                                        on: {
                                                          click:
                                                            _vm.handleCancel,
                                                        },
                                                      }),
                                                      _c("UiButton", {
                                                        attrs: {
                                                          variant: "black",
                                                          type: "submit",
                                                          size: "lg",
                                                          buttonClasses:
                                                            "customPadding w-auto",
                                                          id: "inviteManager",
                                                          disabled:
                                                            _vm.loading ||
                                                            invalid ||
                                                            _vm.users.length >
                                                              50,
                                                          buttonText:
                                                            _vm.loading
                                                              ? "Loading..."
                                                              : "Invite",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      2796054093
                                    ),
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.selectedTabIndex === 1
                            ? _c("CsvUploader", {
                                attrs: {
                                  companyId: _vm.companyId,
                                  csvUploadCompleted: _vm.csvUploadCompleted,
                                  loadingFinished: _vm.uploading,
                                  isManager: true,
                                  usersUnlimited: true,
                                  availableNumberOfManagers: 999999,
                                },
                                on: {
                                  csvUploadUsers: _vm.invite,
                                  close: function ($event) {
                                    return _vm.$emit("input", false)
                                  },
                                  clearCsv: _vm.clearCsv,
                                  wrongExtension: _vm.extensionAlert,
                                  invalidHeaderRow: _vm.invalidHeaderRow,
                                },
                                model: {
                                  value: _vm.csvParseOutput,
                                  callback: function ($$v) {
                                    _vm.csvParseOutput = $$v
                                  },
                                  expression: "csvParseOutput",
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                    ]
                  },
                  proxy: true,
                },
              ],
              null,
              false,
              1344631247
            ),
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }